import { ForwardRefRenderFunction, MouseEventHandler, forwardRef } from 'react';
import cn from 'classnames';

interface ConfigurationHandleProps {
  x: number;
  y: number;
  size: number;
  name?: string;
  onClick?: MouseEventHandler;
  active?: boolean;
  scaleFactor: number;
}

export const ConfigurationHandleWithRef: ForwardRefRenderFunction<
  HTMLButtonElement,
  ConfigurationHandleProps
> = ({ x, y, size, name, onClick, active, scaleFactor }, ref) => {
  return (
    <g
      className={`configuration-handles-zoom__handle__${name}`}
      transform={`translate(${x}, ${y})`}
    >
      <rect width={size} height={size} />
      {active && <circle cx={size / 2} cy={size / 2} r={scaleFactor} fill="#fff" opacity={0.4} />}
      <g transform={`translate(${size / 2 - size / 4}, ${size / 2 - size / 4})`}>
        <circle
          cx={size / 4}
          cy={size / 4}
          r={size / 4}
          fill="#fff"
          stroke="#3B82F6"
          strokeWidth={1.5}
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <foreignObject width={size} height={size}>
        <button
          ref={ref}
          type="button"
          className={cn(
            'configuration-handles-zoom__action',
            name && `configuration-handles-zoom__action__${name}`
          )}
          onClick={onClick}
        ></button>
      </foreignObject>
    </g>
  );
};

export const ConfigurationHandleWithBubble = forwardRef(ConfigurationHandleWithRef);
